<script>
import { onDestroy } from 'svelte';
import { countdown } from '../util';

export let endTime;
let parts;
let timer;

function updateCountdown() {
  timer?.unsubscribe()

  if (!endTime) return;

  timer = countdown(endTime).subscribe(timeleft => {
    parts = timeleft;
    parts.done && timer.unsubscribe();
  })
}

$: endTime, updateCountdown()

onDestroy(() => timer?.unsubscribe())
</script>

{#if !parts.done}
  {#if parts.days > 0}
    {parts.days} {parts.days > 1 ? 'days' : 'day'}
  {/if}

  {#if parts.hours > 0}
    {parts.hours} {parts.hours > 1 ? 'hours' : 'hour'}
  {/if}

  {#if parts.hours > 0 || parts.minutes > 0}
    {parts.minutes} min
  {/if}

  {parts.seconds} sec
{/if}